webpackJsonp([212839066777427],{

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PostNodeFragment = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    li {\n      margin-bottom: 4.5em;\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n  '], ['\n    li {\n      margin-bottom: 4.5em;\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    color: ', ';\n    font-size: 1.433em; \n  '], ['\n    color: ', ';\n    font-size: 1.433em; \n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    &.ui.button {\n      padding: 0;\n      a {\n        padding: 0.5em 1.2em;\n      }\n    }\n  '], ['\n    &.ui.button {\n      padding: 0;\n      a {\n        padding: 0.5em 1.2em;\n      }\n    }\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    flex: 0 1 100%;\n    color: ', ';\n    text-decoration: none;\n\n    div {\n      flex-grow: 1;\n      width: 100%;\n      height: 100%;\n    }\n\n    h3 {\n      font-weight: 600;\n      text-transform: capitalize;\n      text-align: center;\n      margin: 1em 0;\n    }\n  '], ['\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    flex: 0 1 100%;\n    color: ', ';\n    text-decoration: none;\n\n    div {\n      flex-grow: 1;\n      width: 100%;\n      height: 100%;\n    }\n\n    h3 {\n      font-weight: 600;\n      text-transform: capitalize;\n      text-align: center;\n      margin: 1em 0;\n    }\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.ul(_templateObject);
	
	var PostHeaderLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2, function (props) {
	  return props.theme.colors.base;
	});
	
	var ButtonLink = (0, _styledComponents2.default)(_semanticUiReact.Button)(_templateObject3);
	var PostLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4, function (props) {
	  return props.theme.colors.base;
	});
	
	var PostList = function PostList(_ref) {
	  var posts = _ref.posts;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    posts.map(function (_ref2) {
	      var post = _ref2.node,
	          index = _ref2.index;
	      return _react2.default.createElement(
	        'li',
	        { key: post.id },
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3' },
	          _react2.default.createElement(
	            PostHeaderLink,
	            { to: '/blog/' + post.slug + '/' },
	            post.title
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          post.abstract.abstract.substr(0, 50),
	          ' ...'
	        ),
	        _react2.default.createElement(
	          ButtonLink,
	          null,
	          _react2.default.createElement(
	            PostLink,
	            { to: '/blog/' + post.slug + '/' },
	            'Read More'
	          )
	        )
	      );
	    })
	  );
	};
	
	var PostNodeFragment = exports.PostNodeFragment = '** extracted graphql fragment **';
	
	exports.default = PostList;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  flex: 1;\n  height: 100%;\n'], ['\n  flex: 1;\n  height: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 3.06em;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 1em;\n'], ['\n  font-size: 3.06em;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 1em;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(72);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _reactSemanticBooster = __webpack_require__(38);
	
	var _siteConfig = __webpack_require__(33);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _PostList = __webpack_require__(166);
	
	var _PostList2 = _interopRequireDefault(_PostList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Title = _styledComponents2.default.h1(_templateObject2);
	
	var Blog = function Blog(_ref) {
	  var data = _ref.data;
	
	  var posts = data.allContentfulPost.edges;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Blog - ' + _siteConfig2.default.siteTitle
	      ),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Blog - ' + _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:url', content: _siteConfig2.default.siteUrl + '/portfolio/' })
	    ),
	    _react2.default.createElement(
	      _reactSemanticBooster.Block,
	      { spacer: { top: 0.7, bottom: 1 } },
	      _react2.default.createElement(
	        Title,
	        null,
	        'Blog'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { text: true },
	        posts && _react2.default.createElement(_PostList2.default, { posts: posts })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Blog;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-b7610027f7867299e96a.js